import {useForm} from 'react-hook-form'
import {PrizeListModel} from '../../../models/LuckyDraw.model'
import {useSafeFormDateRange} from 'src/app/hooks/safe-form-date-range'
import { useState } from 'react'
import { useSubmitPrize } from '../../../providers/LuckyDraw.provider'

export const defaultPrizeForm: PrizeListModel = {
  id: '',
  description_eng: '',
  description_idn: '',
  draw_directory_id: '',
  draw_date: '',
  type: 'GRAND_PRIZE',
  name: '',
  image: '',
  quantity: undefined,
  directory: {},
  last_print_date: '',
}

export function useAddPrizeForm(props: any) {
  const submit = useSubmitPrize(props?.id as string);

  const form = useForm({defaultValues: defaultPrizeForm, reValidateMode: 'onChange'})
  const minPeriod = useSafeFormDateRange({
    startDateKey: 'draw_date',
    endDateKey: '',
    form,
  })
  const [isEdit, setIsEdit] = useState(false)
  const luckyDrawDetailStatus = props.currentDetail?.status || '';
  
    const enabledFields = ()=> {
      const fields = [
        'id',
        'description_eng',
        'description_idn',
        'draw_date',
        'image',
        'quantity',
        'last_print_date',
      ]
      if (luckyDrawDetailStatus === 'ACTIVE' && isEdit) {
        return fields;
      }
      return [...fields, 'draw_directory_id', 'type', 'name', 'directory']
    }
  return {
    form,
    minPeriod,
    enabledFields,
    setIsEdit,
    isEdit,
    submit,
  }
}
